module.exports = __webpack_public_path__ + "static/media/File-icon.b87de77f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/File-icon.svg
// module id = 904
// module chunks = 0